/** This file is auto generated by convertSvgToJsx.ts */

import React from 'react'
const file_loupe_medium = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="#000"
      d="M2.5 1v.75V1Zm10.036 0V.25 1Zm4.968 6.484a.75.75 0 0 0 1.145-.968l-1.145.968ZM13.3 1.354l.572-.484-.572.484Zm8.67 21.676a.75.75 0 1 0 1.06-1.06l-1.06 1.06Zm-1.44-3.56a.75.75 0 1 0-1.06 1.06l1.06-1.06ZM5 5.75h5.5v-1.5H5v1.5Zm0 3h6.5v-1.5H5v1.5Zm0 11h3.5v-1.5H5v1.5Zm-2.5-18h10.036V.25H2.5v1.5Zm0 22H12v-1.5H2.5v1.5ZM.75 2v20h1.5V2H.75Zm17.9 4.516L13.872.87l-1.145.969 4.777 5.645 1.145-.968ZM2.5 22.25a.25.25 0 0 1-.25-.25H.75c0 .966.784 1.75 1.75 1.75v-1.5Zm10.036-20.5a.25.25 0 0 1 .191.089l1.145-.97A1.75 1.75 0 0 0 12.536.25v1.5ZM2.5.25A1.75 1.75 0 0 0 .75 2h1.5a.25.25 0 0 1 .25-.25V.25Zm16.523 14.886a3.886 3.886 0 0 1-3.887 3.887v1.5a5.386 5.386 0 0 0 5.387-5.387h-1.5Zm-3.887 3.887a3.886 3.886 0 0 1-3.886-3.887h-1.5a5.386 5.386 0 0 0 5.386 5.387v-1.5Zm-3.886-3.887a3.886 3.886 0 0 1 3.886-3.886v-1.5a5.386 5.386 0 0 0-5.386 5.386h1.5Zm3.886-3.886a3.886 3.886 0 0 1 3.887 3.886h1.5a5.386 5.386 0 0 0-5.387-5.386v1.5Zm4.334 9.28 2.5 2.5 1.06-1.06-2.5-2.5-1.06 1.06Z"
    />
  </svg>
)
export default file_loupe_medium
